// extracted by mini-css-extract-plugin
module.exports = {"container":"EnrollmentStatus_container__R0FZt","content":"EnrollmentStatus_content__1EabW","status":"EnrollmentStatus_status__1vP5E"};